import {
  AnalyticsTranslationKeys,
  CommonTranslationKeys,
  ExtendedFieldTranslationKeys,
  FiltersTranslationKeys,
} from 'intl/keys';
import { IssueChartFilterKind } from 'shared/domain/analytics/issueChartFilters';
import { IssueFieldNames } from 'shared/domain/issueForm/types/fieldNames';
import type { IssueChartFilterDescriptor } from './types';

/** The label and related issue field of each kind of filter, the same on every issue chart. */
export const ISSUE_CHART_FILTER_DESCRIPTORS: Readonly<Record<IssueChartFilterKind, IssueChartFilterDescriptor>> = {
  [IssueChartFilterKind.originators]: {
    labelId: AnalyticsTranslationKeys.originators,
    fieldRelation: IssueFieldNames.subcontractors,
  },
  [IssueChartFilterKind.process]: {
    labelId: CommonTranslationKeys.process,
  },
  [IssueChartFilterKind.sites]: {
    labelId: AnalyticsTranslationKeys.sites,
    fieldRelation: IssueFieldNames.site,
  },
  [IssueChartFilterKind.workType]: {
    labelId: ExtendedFieldTranslationKeys.workType,
    fieldRelation: IssueFieldNames.workTypes,
  },
  [IssueChartFilterKind.impact]: {
    labelId: ExtendedFieldTranslationKeys.impact,
    fieldRelation: IssueFieldNames.impact,
  },
  [IssueChartFilterKind.assignee]: {
    labelId: FiltersTranslationKeys.filterTypeAssignee,
    fieldRelation: IssueFieldNames.assignee,
  },
};
